import React, { Component } from 'react'; 
import {Row , Col, Button, Modal } from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
 export default class FormMapping extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      selectedAuditType:[],
      selectedComplianceType:[],      
      selectedTemplate:[]
    }
    this.bulkclientName = []
  }
  componentDidMount(){
    this.props.function.TokenValidation()  
    this.props.function.actioninventoryUserMapped()
    this.props.function.templateNames() 
    this.props.function.AuditTypeList()
  }
  componentWillMount = () => {     
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
      }    
  }
  regionNames = (prop) => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    const{inventory} = this.props;
    if(!_.isEmpty(inventory) && !_.isEmpty(selectedregionName)){
   // _.map(selectedregionName, (obj)=>{
        let centerName = _.filter(selectedregionName.userCenters);
      //  centerName.push(...x );
    //})   
      return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    const{inventory} = this.props;
    let clientName=[];
    if(!_.isEmpty(inventory)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    const{inventory} = this.props;
    let processName=[];
    if(!_.isEmpty(inventory)){
    _.map(selectedclientName, (obj)=>{
        let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
      _.map(abc, (z) => {
        processName.push(...z.userProcesses)
        processName = _.uniqBy(processName, 'inventoryProcessId');
      }) 
    }) 
    return processName;
    }
  }
  TemplateName = () => {
    const{nameList} = this.props;
    if(!_.isEmpty(nameList)){
      let TemplateName = _.filter(nameList); 
      return TemplateName;
    }
  }
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e} );
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[], selectedcenterName:[]}) 
     }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[]}) 
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[]}) 
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});
  }
  handleSelectTemplate = (e) => {
    this.setState({selectedTemplate: e});
  }
  validateForm = () =>{
    const {selectedclientName,selectedprocessName,selectedcenterName,selectedAuditType,selectedTemplate} = this.state;
      if(selectedcenterName.length>0 && selectedclientName.length >0 && selectedprocessName.length > 0 &&
        !_.isEmpty(selectedAuditType) && !_.isEmpty(selectedTemplate) ){
        return true }
  } 
  mapTemplate = () => {
    const {selectedclientName,selectedprocessName,selectedcenterName,selectedAuditType,
      selectedTemplate, selectedregionName, selectedComplianceType} = this.state;
      let centers = _.map(selectedcenterName, (cx) => { 
      let clients = [] ; let process = [];
      if(!_.isEmpty(cx.userClients)){
        _.map(selectedclientName, (obj) =>{
           _.map(cx.userClients, val =>{
            if(_.isEqual(val.inventoryClientId, obj.inventoryClientId)){
              if(!_.isEmpty(val.userProcesses)){
                _.map(selectedprocessName, (object) => {
                  let data = _.filter(val.userProcesses, object)
                  process.push(...data)
                })           
              } 
              clients.push(
                {'clientId':obj.inventoryClientId, 'clientName':obj.inventoryClientName, 'process':process}
                )
            }
            process = [];
          }) 
        })
      }
      return(
      {'centerId':cx.inventoryCenterId, 'centerName':cx.inventoryCenterName, 'client':clients}
    )})
    let object =  {
      'region':{'regionId': selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName},
      'center':centers,
      'auditType':(selectedAuditType === 'Compliance Audit') ? selectedComplianceType : selectedAuditType, 
      'templateName':selectedTemplate.templateName
    }

    this.props.function.TokenValidation()  
    this.props.function.TemplateMapping(object)
    this.setState({confirmMap:true})   
  }
  confirmMapping = () =>{
    const{mapSucess} = this.props;
    if(!_.isEmpty(mapSucess)){
     return(
    <Modal show={this.state.confirmMap}
    onHide={this.confirmMapClose}
    dialogClassName="modal-120w shadowClass"
    size='md'
    aria-labelledby="contained-modal-title-vcenter"
    centered>          
    <Modal.Header closeButton><Modal.Title>Save changes</Modal.Title></Modal.Header>
    <Modal.Body>{mapSucess.message}  
    </Modal.Body>
    <Modal.Footer>
      {mapSucess.isExists === true ?   
      <p>
         <Button className='buttonwidth' onClick={this.confirmMapOKClose}> OK </Button> &nbsp;
         <Button className='buttonwidth' onClick={this.confirmMapCancelClose}> Cancel </Button>
      </p> : 
      <Button onClick={this.confirmMapClose}> OK </Button> }
    </Modal.Footer>
    </Modal>)
    }
  }
   confirmMapOKClose = () =>{
    this.setState({confirmMap:false})
    this.props.function.formTemplateExist({'isExists':true})
    this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], selectedTemplate:[]})
  }
  confirmMapCancelClose = () =>{
    this.setState({confirmMap:false})
    this.props.function.formTemplateExist({'isExists':false})
    this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], selectedTemplate:[]})
  }
  confirmMapClose = () =>{
    this.setState({confirmMap:false})
    this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], selectedTemplate:[]})
  }
  handleSelectAudit = (e) => {
    this.setState({selectedAuditType:e})
  }
  handleSelectAuditType = (e) => {
    this.setState({selectedComplianceType:e})
  }
  
  render(){
    let auditTypeVal=[];    
    if(!_.isEmpty(this.props.function.auditTypes)){
      auditTypeVal = this.props.function.auditTypes.auditType
    }
      return(
        <div className='margingap'>
            <Row>
              <Col>
                <label>Region Name</label>
              </Col>
              <Col>
              <Picky keepOpen={false}
                value={this.state.selectedregionName}
                options={this.regionNames()}
                onChange={this.handleSelect}
                open={false}
                valueKey="inventoryRegionName"
                labelKey="inventoryRegionName"
                multiple={false}
                includeSelectAll={false}
                includeFilter={true}
                clearFilterOnClose={true}
                placeholder='Select Region'
                dropdownHeight={600}
              />
              </Col>
            </Row> 
            <Row>
              <Col>
                <label>Center Name</label>
              </Col>
              <Col>
              <Picky keepOpen={false}
                value={this.state.selectedcenterName}
                options={this.centerNames()}
                onChange={this.handleSelectCenter}
                open={false}
                valueKey="inventoryCenterName"
                labelKey="inventoryCenterName"
                multiple={true}
                includeSelectAll={true}
                includeFilter={true}
                clearFilterOnClose={true}
                placeholder='Select Center'
                dropdownHeight={600}
              />
              </Col>             
            </Row>
            <Row>
            <Col>
            <label>Client Name</label>
            </Col>
            <Col>
            <Picky keepOpen={false}
              value={this.state.selectedclientName}
              options={this.clientNames()}
              onChange={this.handleSelectClient}
              open={false}
              valueKey="inventoryClientName"
              labelKey="inventoryClientName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Client'
              dropdownHeight={600}
            />
            </Col>
            </Row> 
            <Row>
            <Col>
            <label>Process Name</label>
            </Col>
            <Col>
            <Picky keepOpen={false}
              value={this.state.selectedprocessName}
              options={this.processNames()}
              onChange={this.handleSelectProcess}
              open={false}
              valueKey="inventoryProcessName"
              labelKey="inventoryProcessName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Process Name'
              dropdownHeight={600}
            />
              </Col>
              </Row>
            <Row>
            <Col>
            <label>Audit Type</label>
            </Col>
            <Col>
            <Picky keepOpen={false}
              value={this.state.selectedAuditType}
              options={auditTypeVal}
              onChange={this.handleSelectAudit}
              open={false}
              //valueKey="label"
              //labelKey="label"
              multiple={false}
              includeSelectAll={false}
              includeFilter={false}
              placeholder='Select Audit'
              dropdownHeight={600}
            />
              </Col>
              </Row>
              {this.state.selectedAuditType === "Compliance Audit" ? 
              <Row>
              <Col>
              <label>Compliance Audit Types</label>
              </Col>
              <Col>
              <Picky keepOpen={false}
                value={this.state.selectedComplianceType}
                options={this.props.function.auditTypes.complianceTypeAudit}
                onChange={this.handleSelectAuditType}
                open={false}
                valueKey="label"
                labelKey="label"
                multiple={false}
                includeSelectAll={false}
                includeFilter={false}
                placeholder='Select Audit Type'
                dropdownHeight={600}
              />
                </Col>
                </Row>
            : null }

            <Row>
            <Col>
            <label>Template Name</label>
            </Col>
            <Col>
            <Picky keepOpen={false}
              value={this.state.selectedTemplate}
              options={this.TemplateName()}
              onChange={this.handleSelectTemplate}
              open={false}
              valueKey="templateName"
              labelKey="templateName"
              multiple={false}
              includeSelectAll={false}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Template'
              dropdownHeight={600}
            />
              </Col>
              </Row>
              <br/>
              <Row>
                <Col>
                <Button className='buttonwidth' onClick={this.mapTemplate} block disabled={!this.validateForm()}>UPDATE</Button></Col>
                {this.state.confirmMap ? this.confirmMapping(this.props.mapSucess) : null}
              </Row>
        </div>);
      
    } 
    

  }

